/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export const selectAll = (element: HTMLSpanElement): void => {
  let range = document.createRange();
  range.selectNodeContents(element);
  let sel = window.getSelection()!;
  sel.removeAllRanges();
  sel.addRange(range);
};

export const clearSelection = (): void => {
  if (window.getSelection) {
    if (window.getSelection()?.empty) {
      // Chrome
      window.getSelection()?.empty();
    } else if (window.getSelection()?.removeAllRanges) {
      // Firefox
      window.getSelection()?.removeAllRanges();
    }
  }
};
